'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);

var useIsOverflow = function (ref) {
    var _a = tslib_es6.__read(React.useState(false), 2), isOverflow = _a[0], setIsOverflow = _a[1];
    React.useEffect(function () {
        var current = ref.current;
        var trigger = function () {
            var hasOverflow = !current ? false : current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
        };
        if (current) {
            trigger();
        }
    }, [ref]);
    return isOverflow;
};

exports.useIsOverflow = useIsOverflow;
